import { Button, ChangeEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDistanceCalculatorOverview } from "./autogen/AutogenLayoutDistanceCalculatorOverview";

export class DistanceCalculatorOverview extends AutogenLayoutDistanceCalculatorOverview {
    private previousShortProfile: string | null = null;
    private previousPracticalProfile: string | null = null;

    override onLoad(): void {
        this.lookupModelShortAndPracticalDistance();
    }

    /** When Screen loads call the QUERY_MODEL_ENDPOINT and populate the list of distance Profile */
    private async lookupModelShortAndPracticalDistance() {
        await this.sourceDistanceControl.search();
        this.layoutShortDistanceRateConfig?.setPanel1ServerToUse(this.textboxShortDistProfile.text);
        this.layoutPracticalDistanceRateConfig?.setPanel2ServerToUse(this.textboxPracticalProfile.text);
    }

    public showMilesAndTollAmount(response: any) {
        if (response?.short_mileage != undefined) {
            const shortTollAmount = response?.short_toll_amount;
            this.labelShortMilesCalculateValue.text = response?.short_mileage;
            this.labelShortTollAmntCalculateValue.text = shortTollAmount.symbol + shortTollAmount.amount;
            this.labelShortTollAmntCalculateValue.color = response?.short_toll_amount_color;
        }

        if (response?.practical_mileage != undefined) {
            const practicalTollAmount = response?.practical_toll_amount;
            this.labelPracticalMilesCalculateValue.text = response?.practical_mileage;
            this.labelPracticalTollAmntCalculateValue.text = practicalTollAmount.symbol + practicalTollAmount.amount;
            this.labelPracticalTollAmntCalculateValue.color = response?.practical_toll_amount_color;
        }
    }

    public setMainPanelShortDistanceVisible(visible: boolean) {
        this.mainPanelShortDistance.visible = visible;
    }

    public setPanelShortDistanceVisible(visible: boolean) {
        this.panelShortDistance.visible = visible;
    }

    public setTextboxShortDistProfileVisible(visible: boolean) {
        this.textboxShortDistProfile.visible = visible;
    }

    public setMainPanelPracticalDistanceVisible(visible: boolean) {
        this.mainPanelPracticalDistance.visible = visible;
    }

    public setPanelPracticalDistanceVisible(visible: boolean) {
        this.panelPracticalDistance.visible = visible;
    }

    public setPanelOverviewSummaryVisible(visible: boolean) {
        this.panelOverviewSummary.visible = visible;
    }

    public setTextboxPracticalDistProfileVisible(visible: boolean) {
        this.textboxPracticalProfile.visible = visible;
    }

    displayShortProfileConfig(display: boolean) {
        this.layoutShortDistanceRateConfig.visible = display;
    }

    displayPracticalProfileConfig(display: boolean) {
        this.layoutPracticalDistanceRateConfig.visible = display;
    }

    private enableProfileAndRotateChevron(buttonExpandConfig: Button, textboxProfile: Textbox, profileType: string) {
        const expanded = buttonExpandConfig.imageRotation == 0;
        buttonExpandConfig.imageRotation = expanded ? 90 : 0;
        if (expanded) {
            // Restore previous value when collapsing
            if (profileType === "short" && this.previousShortProfile != null) {
                textboxProfile.text = this.previousShortProfile;
                textboxProfile.setSelectedItemFromDisplayValue(this.previousShortProfile);
                this.sourceDistanceControl.activeRow.set("short_dist_profile", this.previousShortProfile);
            }
            if (profileType === "practical" && this.previousPracticalProfile != null) {
                textboxProfile.text = this.previousPracticalProfile;
                textboxProfile.setSelectedItemFromDisplayValue(this.previousPracticalProfile);
                this.sourceDistanceControl.activeRow.set("prac_dist_profile", this.previousPracticalProfile);
            }
        } else {
            // Store previous value before clearing
            if (profileType === "short") {
                this.previousShortProfile = textboxProfile.text;
            } else {
                this.previousPracticalProfile = textboxProfile.text;
            }
            textboxProfile.clear();
        }
        textboxProfile.enabled = expanded;
    }

    public isShortConfigExpanded() {
        return this.buttonExpandShortConfig.imageRotation === 0;
    }

    public isPracticalConfigExpanded() {
        return this.buttonExpandPracticalConfig.imageRotation === 0;
    }

    /** This is an event handler for the onClick event of buttonExpandShortConfig.  */
    buttonExpandShortConfigOnClick() {
        this.enableProfileAndRotateChevron(this.buttonExpandShortConfig, this.textboxShortDistProfile, "short");
        this.displayShortProfileConfig(this.buttonExpandShortConfig.imageRotation == 0);
    }

    /** This is an event handler for the onClick event of buttonExpandPracticalConfig.  */
    buttonExpandPracticalConfigOnClick() {
        this.enableProfileAndRotateChevron(this.buttonExpandPracticalConfig, this.textboxPracticalProfile, "practical");
        this.displayPracticalProfileConfig(this.buttonExpandPracticalConfig.imageRotation == 0);
    }

    textboxShortDistProfileOnChange(event: ChangeEvent) {
        const profileName = this.textboxShortDistProfile.text === "" ? event.oldValue : this.textboxShortDistProfile.text;
        this.layoutShortDistanceRateConfig?.setPanel1ServerToUse(profileName);
    }

    textboxPracticalProfileOnChange(event: ChangeEvent) {
        const profileName = this.textboxPracticalProfile.text === "" ? event.oldValue : this.textboxPracticalProfile.text;
        this.layoutPracticalDistanceRateConfig?.setPanel2ServerToUse(profileName);
    }
}
